module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0063.jpg?v=81422526";